import App from "./components/Router";

export default App;
